module.exports = __webpack_public_path__ + "static/thumbnail-d5d7d9990120cc2363d05e74fa8d2cd7.png";